import { FC, memo } from 'react';
import { format } from 'date-fns';

import { Group } from '@visx/group';

import { MwdStatusVanWerklijn } from '../../types/Domain';

type OvergangProps = {
  statusOvergang: MwdStatusVanWerklijn;
};

const WerklijnStatusOvergang: FC<OvergangProps> = ({ statusOvergang }) => {
  return (
    <svg>
      <Group left={statusOvergang.x}>
        <rect
          id={`so-${statusOvergang.eenheidsnummer}:${format(new Date(statusOvergang.begindatumtijd), `yyyy-MM-dd-HH:mm`)}`}
          width={statusOvergang.width}
          fill='url(#arceringPattern)'
          key={`overgang_${statusOvergang.eenheidsnummer}`}
          height={22}
          data-is-statusovergang={true}
        />
      </Group>
    </svg>
  );
};

export default memo(WerklijnStatusOvergang);
